var map = {
	"./Article": 2064,
	"./Article/": 2064,
	"./Article/index": 2064,
	"./Article/index.jsx": 2064,
	"./Article/styles.module.css": 50574,
	"./ContactLayout": 73676,
	"./ContactLayout/": 73676,
	"./ContactLayout/SimpleCheckbox": 10903,
	"./ContactLayout/SimpleCheckbox/": 10903,
	"./ContactLayout/SimpleCheckbox/index": 10903,
	"./ContactLayout/SimpleCheckbox/index.jsx": 10903,
	"./ContactLayout/SimpleCheckbox/styles.module.css": 79498,
	"./ContactLayout/SimpleRadioButton": 59473,
	"./ContactLayout/SimpleRadioButton/": 59473,
	"./ContactLayout/SimpleRadioButton/index": 59473,
	"./ContactLayout/SimpleRadioButton/index.jsx": 59473,
	"./ContactLayout/SimpleRadioButton/styles.module.css": 45046,
	"./ContactLayout/index": 73676,
	"./ContactLayout/index.jsx": 73676,
	"./ContactLayout/styles.module.css": 13025,
	"./CustomLayout": 64205,
	"./CustomLayout/": 64205,
	"./CustomLayout/index": 64205,
	"./CustomLayout/index.jsx": 64205,
	"./CustomLayout/styles.module.css": 83646,
	"./FeaturesLayout": 15919,
	"./FeaturesLayout/": 15919,
	"./FeaturesLayout/index": 15919,
	"./FeaturesLayout/index.jsx": 15919,
	"./FeaturesLayout/styles.module.css": 9576,
	"./FooterLayout": 93444,
	"./FooterLayout/": 93444,
	"./FooterLayout/index": 93444,
	"./FooterLayout/index.jsx": 93444,
	"./FooterLayout/styles.module.css": 42113,
	"./HeroLayout": 34142,
	"./HeroLayout/": 34142,
	"./HeroLayout/index": 34142,
	"./HeroLayout/index.jsx": 34142,
	"./HeroLayout/styles.module.css": 42803,
	"./MenuLayout": 49956,
	"./MenuLayout/": 49956,
	"./MenuLayout/index": 49956,
	"./MenuLayout/index.jsx": 49956,
	"./MenuLayout/styles.module.css": 86857,
	"./StoryLayout": 7103,
	"./StoryLayout/": 7103,
	"./StoryLayout/index": 7103,
	"./StoryLayout/index.jsx": 7103,
	"./StoryLayout/styles.module.css": 4921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39077;